// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  clashId: __t.u64().primaryKey().name("clash_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  z: __t.f32(),
  aggressorSid: __t.u64().name("aggressor_sid"),
  defenderSid: __t.u64().name("defender_sid"),
  fallenName: __t.string().name("fallen_name"),
  endsAt: __t.timestamp().name("ends_at"),
  at: __t.timestamp(),
});
